BryanAnthonys.loadedScripts['product-reviews'] = true;

class ProductReviews extends HTMLElement {
    initialize() {
        this.section = this.querySelector('[data-section-content]');
        this.initialData = null;
        this.currentSort = null;

        const initialReviewsData = this.getInitialReviewsData();
        if (initialReviewsData && initialReviewsData.data.length) {
            this.initialData = initialReviewsData;
            this.render(initialReviewsData);
        }

        if (this.dataset.isOnProductPage) {
            this.captureRatingLinkClicks();
        }
    }

    render(data) {
        const html = this.shouldRenderSlider() ? this.renderSlider(data) : this.renderStack(data);

        this.section.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(html));
    }

    renderSlider(data) {
        const reviews = data.data.slice(0, this.getLimit());
        const id = Math.round(Math.random() * 1000000);

        let sliderClasses = 'slider-component-desktop slider-mobile-no-gutter';
        const sliderId = `Slider-reviews-${id}`;
        const ulClasses = 'grid grid--4-col-desktop grid--1-partial-col slider slider--desktop slider--tablet mt-4 mt-5-desktop';
        const liClasses = 'grid__item slider__slide';

        const slides = reviews.map((review, index) => `
            <li id="Slide-reviews-${id}-${index}" class="${liClasses}">
                ${this.renderReviewCard(review)}
            </li>
        `);

        return `
            <slider-component class="${sliderClasses}" data-has-media-slides="true" data-free-scroll="auto">
                <ul id="${sliderId}" role="list" aria-label="Reviews Slider" class="${ulClasses}">
                    ${slides.join('')}
                </ul>
                <div class="slider-buttons no-js-hidden slider-buttons--sides slider-buttons--outside">
                    <button type="button" class="slider-button slider-button--prev slider-button--highlight" name="previous"
                            aria-label="Slide left" aria-controls="${sliderId}" disabled="disabled">
                        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 46 26" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M45 1L22.9127 25L1 0.999998" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                        </svg>
                    </button>
                    <div class="slider-counter caption visually-hidden">
                        <span class="slider-counter--current">1</span>
                        <span aria-hidden="true"> / </span>
                        <span class="visually-hidden">of</span>
                        <span class="slider-counter--total">${reviews.length}</span>
                    </div>
                    <button type="button" class="slider-button slider-button--next slider-button--highlight" name="next"
                            aria-label="Slide right" aria-controls="${sliderId}" disabled="disabled">
                        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 46 26" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M45 1L22.9127 25L1 0.999998" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                        </svg>
                    </button>
                </div>
                <global-element-initializer></global-element-initializer>
            </slider-component>
        `;
    }

    renderStack(data) {
        const reviews = data.data.slice(0, this.getLimit());
        const options = {
            cardClasses: 'mb-3 review-card--bordered'
        };

        return `
            <div class="product-reviews__stack mt-3 mt-4-desktop">
                <div class="product-reviews__stack-cards">
                    ${reviews.map(review => this.renderReviewCard(review, options)).join('')}
                </div>
            </div>
        `;
    }

    renderSortButtons(position, active = '') {
        return `
            <reviews-sort 
                class="scrollable block product-reviews-sort pb-3 center-desktop" 
                data-current-sort="${active}" data-position="${position}"
            >
                <ul class="scrollable__list" aria-label="Options to sort reviews">
                    <li class="scrollable__item pt-1 pb-1 mr-1 scrollable__item--most-votes">
                        <button type="button" value="most-votes" class="button button--small button--badge letter-spacing-normal" aria-label="Sort reviews by most votes">
                            ${this.dataset.sortVotesText}
                        </button>
                    </li>
                    <li class="scrollable__item pt-1 pb-1 mr-1 scrollable__item--photos">
                        <button type="button" value="photos" class="button button--small button--badge letter-spacing-normal" aria-label="Sort reviews by customer photo">
                            ${this.dataset.sortPhotosText}
                        </button>
                    </li>
                    <li class="scrollable__item pt-1 pb-1 mr-1 scrollable__item--featured">
                        <button type="button" value="featured" class="button button--small button--badge letter-spacing-normal" aria-label="Sort reviews by featured">
                            ${this.dataset.sortFeaturedText}
                        </button>
                    </li>
                    <li class="scrollable__item pt-1 pb-1 mr-1 scrollable__item--highest-rating">
                        <button type="button" value="highest-rating" class="button button--small button--badge letter-spacing-normal" aria-label="Sort reviews by highest rating">
                            ${this.dataset.sortHighText}
                        </button>
                    </li>
                    <li class="scrollable__item pt-1 pb-1 mr-1 scrollable__item--lowest-rating">
                        <button type="button" value="lowest-rating" class="button button--small button--badge letter-spacing-normal" aria-label="Sort reviews by lowest rating">
                            ${this.dataset.sortLowText}
                        </button>
                    </li>
                </ul>
                <reviews-element-initializer></reviews-element-initializer>
            </reviews-sort>
        `;
    }

    renderReviewCard(review, options = {}) {
        BryanAnthonys.unsafeDataBag[`review-data-${parseInt(review.id)}`] = review;

        const ratingsPercentage = Math.round((review.reviewRating / 5) * 100);
        const starsLabel = BryanAnthonys.strings.accessibility.starReviewsInfo.replace(
            '{{ ratings_average }}',
            parseInt(review.reviewRating)
        );

        let customerImageButton = '';
        if (review.reviewUserPhotos && typeof review.reviewUserPhotos === 'string') {
            customerImageButton = `
                <div class="review-card__footer-media">
                    <review-modal-opener 
                        class="review-modal-opener review-card-media" 
                        data-modal-id="in-card-${parseInt(review.id)}" data-review-id="${parseInt(review.id)}"
                        data-cdn-url="${this.dataset.customerImageCdn}"
                    >
                        <button class="review-image-button media" type="button" aria-label="View image uploaded by customer">
                            <img alt="Photo uploaded by customer" width="100" height="100">
                        </button>
                        <reviews-element-initializer></reviews-element-initializer>
                    </review-modal-opener>
                </div>
            `;
        }

        let reply = '';
        if (review.reviewReply) {
            reply = `
                <span class="review-card__reply">
                    <strong>${this.dataset.replyText}</strong>
                    <span data-review-reply-text></span>
                </span>
            `;
        }

        return `
            <review-card class="card review-card ${options.cardClasses || ''}" data-id="${parseInt(review.id)}">
                <div class="review-card__header">
                    <span class="review-card__author" data-review-author></span>
                    <span class="product-rating-stars review-card__stars" role="img" aria-label="${starsLabel}">
                        <span class="product-rating-full-stars review-card__rating-full-stars" 
                            style="width: ${ratingsPercentage}%"></span>
                    </span>
                    <div class="review-card__header-right">
                        <span class="review-card__date" data-review-date></span>
                        <span class="review-card__location" data-review-location></span>
                        <span class="review-card__verification">
                            <svg
                                class="icon icon-check" aria-hidden="true"  focusable="false"
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 32" fill="none"
                            >
                                <path d="M1 17.0345L15.8046 31L46 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            ${this.dataset.verifiedText}
                        </span>
                    </div>
                </div>
                <div class="review-card__body">
                    <span class="review-card__title" data-review-title></span>
                    <span class="review-card__message">
                        <span data-review-message></span>
                        ${reply}
                    </span>
                </div>
                <review-card-footer class="review-card__footer pt-4" data-review-id="${parseInt(review.id)}">
                    <span class="inline-block review-card__footer-intro">${this.dataset.voteIntro}</span>
                    <button class="vote-review-button" type="button" data-vote-up aria-label="Vote up review" data-votes="(${parseInt(review.reviewVotesUp)})">
                        <img src="${this.dataset.iconHeartSrc}" width="16" height="16" loading="lazy" alt="Vote up review"/>
                    </button>
                    ${customerImageButton}
                </review-card-footer>
                <reviews-element-initializer></reviews-element-initializer>
            </review-card>
        `;
    }

    shouldRenderSlider() {
        return window.matchMedia('(min-width: 1200px)').matches;
    }

    getLimit() {
        return this.shouldRenderSlider()
            ? parseInt(this.dataset.fetchLimit)
            : parseInt(this.dataset.stackLimit);
    }

    getInitialReviewsData() {
        const jsonElement = this.querySelector('[data-initial-json]');
        if (!jsonElement) {
            return null;
        }

        const json = jsonElement.innerHTML;
        if (json === 'null') {
            return null;
        }

        return JSON.parse(json);
    }

    fetchReviews(filters = {}) {
        const url = this.dataset.reviewsUrl;
        const params = new URLSearchParams();
        params.set('storeUrl', this.dataset.store);
        params.set('apiKey', this.dataset.apiKey);
        params.set('productId', this.dataset.productId);
        params.set('take', this.dataset.fetchLimit);
        for (const paramName in filters) {
            params.set(paramName, filters[paramName]);
        }

        return new Promise(function (resolve, reject) {
            fetch(`${url}?${params.toString()}`)
                .then(BryanAnthonys.decodeJsonResponse)
                .then(resolve)
                .catch(reject);
        });
    }

    fetchSummary() {
        const url = this.dataset.reviewsSummaryUrl;
        const data = BryanAnthonys.makePostConfig('json');
        data.body = JSON.stringify({
            productIds: [{productId: this.dataset.productId}],
            apiKey: this.dataset.apiKey,
            storeUrl: this.dataset.store
        });

        return new Promise(function (resolve, reject) {
            fetch(url, data)
                .then(BryanAnthonys.decodeJsonResponse)
                .then(resolve)
                .catch(reject);
        });
    }

    captureRatingLinkClicks() {
        document.querySelectorAll('a[class="product__rating-caption-link"]').forEach(link => {
            const hideReviewsForm = () => {
                setTimeout(() => {
                    const form = document.querySelector('reviews-drawer.active review-form');
                    const formIsHidden = form && form.classList.contains('hidden');
                    const opener = document.querySelector('reviews-drawer.active review-form-opener');

                    if (!formIsHidden && opener) {
                        opener.click();
                    }
                }, 100);
            };

            link.setAttribute('role', 'button');
            link.addEventListener('click', event => {
                event.preventDefault();
                this.openDrawer(event.target);
                hideReviewsForm();
            });

            link.addEventListener('keydown', event => {
                if (event.code && event.code.toUpperCase() === 'SPACE') {
                    event.preventDefault();
                    this.openDrawer(event.target);
                    hideReviewsForm();
                }
            });
        });
    }

    openDrawer(opener) {
        if (!this.drawer) {
            const drawer = document.createElement('reviews-drawer');
            drawer.classList.add('reviews-drawer', 'drawer');
            drawer.dataset.sectionId = this.dataset.sectionId;
            drawer.dataset.productId = this.dataset.productId;
            document.body.appendChild(drawer);
            this.drawer = drawer;
        }

        setTimeout(() => this.drawer.open(opener), 50);
    }
}

customElements.define('product-reviews', ProductReviews);

class ReviewCard extends HTMLElement {
    initialize() {
        this.data = BryanAnthonys.unsafeDataBag[`review-data-${this.dataset.id}`];

        this.renderUnsafeData();
    }

    renderUnsafeData() {
        if (this.data.reviewReply) {
            this.querySelector('[data-review-reply-text]').innerText = this.data.reviewReply;
        }

        this.querySelector('[data-review-author]').innerText = this.data.author;
        this.querySelector('[data-review-date]').innerText = this.data.reviewDate;
        this.querySelector('[data-review-location]').innerText = this.data.location;
        this.querySelector('[data-review-title]').innerText = this.data.reviewTitle;
        this.querySelector('[data-review-message]').innerText = this.data.reviewMessage;
    }
}

customElements.define('review-card', ReviewCard);

class ReviewsDrawer extends HTMLElement {
    connectedCallback() {
        this.productReviews = document.querySelector(`product-reviews[data-section-id="${this.dataset.sectionId}"]`);
        this.currentSort = this.productReviews.currentSort || '';

        this.render(this.productReviews.initialData);
        this.page = 1;

        this.productReviews.fetchSummary()
            .then(summary => this.fillBreakdown(summary[0]))
            .catch(error => console.error(error));

        this.addEventListener('click', event => {
            if (
                event.target === this
                || event.target.hasAttribute('data-close')
                || event.target.closest('button[data-close]')
            ) {
                this.close();

                return;
            }

            const ratingFilterButton = event.target.closest('[data-rating-filter-button]');
            if (ratingFilterButton) {
                if (ratingFilterButton.dataset.count !== '0') {
                    this.filterByRating(ratingFilterButton);
                }

                return;
            }

            const loadMoreButton = event.target.hasAttribute('data-load-more')
                ? event.target
                : event.target.closest('[data-load-more]');

            if (loadMoreButton) {
                this.loadMoreReviews(loadMoreButton);
            }
        });

        document.addEventListener('modalDialogHidden', () => {
            if (this.isOpen() && !document.querySelector('modal-dialog[open]')) {
                this.trapScrollAndFocus(null);
            }
        });

        this.addEventListener('keyup', event => {
            if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.isOpen()) {
                this.close();
            }
        });

        this.initInfiniteScroll();
    }

    // eslint-disable-next-line max-lines-per-function
    render(data) {
        let existingReviews = '';

        if (data && data.rating > 0) {
            const ratingsPercentage = Math.round((data.rating / 5) * 100);
            const starsLabel = BryanAnthonys.strings.accessibility.starReviewsInfo.replace(
                '{{ ratings_average }}',
                data.rating
            );

            const breakdownButtons = [5, 4, 3, 2, 1].map(rating => {
                const ratingsPercentage = Math.round((rating / 5) * 100);
                const starsLabel = BryanAnthonys.strings.accessibility.starReviewsInfo.replace(
                    '{{ ratings_average }}',
                    rating
                );

                return `
                    <button 
                        type="button" class="product-rating-stars__button block" data-rating${rating} 
                        data-count="0" data-rating-filter-button data-rating-score="${rating}" aria-label="Show ${rating} star reviews first"
                    >
                        <span class="product-rating-stars product-reviews-breakdown__stars" role="img" aria-label="${starsLabel}">
                            <span class="product-rating-full-stars product-reviews-breakdown__full-stars" 
                                style="width: ${ratingsPercentage}%"></span>
                        </span>
                        <span class="">${rating} Stars</span>
                        <span 
                            class="product-reviews-breakdown__count inline-block ml-1 light-weight size-13" 
                            data-count-text
                        >0</span>
                    </button>
                `;
                }).join('');

            const reviews = data.data;

            existingReviews = `
                <h3 class="size-15 size-17-desktop uppercase letter-spacing-1 semi-heavy-weight pb-3 pt-3 pl-4 pr-4 left reviews-drawer__heading">
                    ${this.productReviews.dataset.heading}
                </h3>
                <div class="reviews-drawer__summary pl-4 pr-4">
                    <reviews-details>
                        <details class="reviews-details">
                            <summary class="reviews-details__summary light-weight size-13 size-14-desktop">
                                <span class="product-rating-stars reviews-details__summary-stars inline-block" role="img" aria-label="${starsLabel} - ${parseInt(data.total)} reviews)">
                                    <span class="product-rating-full-stars reviews-drawer__summary-full-stars" 
                                        style="width: ${ratingsPercentage}%"></span>
                                </span>
                                <span aria-hidden="true">
                                    ${data.rating.toFixed(2).replace('.00', '.0')} | 
                                    ${this.productReviews.dataset.summaryCountText.replace('{{ count }}', parseInt(data.total))}
                                </span>
                                <span class="css-caret"></span>
                            </summary>
                            <product-reviews-breakdown class="reviews-details__dropdown product-reviews-breakdown block">
                                ${breakdownButtons}
                            </product-reviews-breakdown>
                        </details>
                        <reviews-element-initializer></reviews-element-initializer>
                    </reviews-details>
                    <review-form-opener class="block ml-auto">
                        <button 
                            type="button" class="link size-13 size-14-desktop light-weight" aria-expanded="false"
                            aria-controls="review-form-${this.dataset.sectionId}"
                        >
                            ${this.productReviews.dataset.writeText}
                        </button>
                    </review-form-opener>
                </div>
                <review-form class="review-form block pt-5 pb-5 pl-4 pr-4 hidden" id="review-form-${this.dataset.sectionId}"></review-form>
                <div class="product-reviews__stack mt-3" data-reviews-stack>
                    ${this.productReviews.renderSortButtons('drawer-stack', this.productReviews.currentSort)}
                    <div class="product-reviews__stack-cards" data-reviews-stack-cards>
                        ${reviews.map(review => this.productReviews.renderReviewCard(review)).join('')}
                    </div>
                    <div class="center">
                        ${data.total > reviews.length ? this.renderLoadMoreButton(2) : ''}
                    </div>
                </div>
            `;
        }

        const visibleReviewsForm = `
            <review-form class="review-form block pt-5 pb-5 pl-4 pr-4" id="review-form-${this.dataset.sectionId}"></review-form>
        `;

        this.innerHTML = BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <button class="reviews-drawer__close" aria-label="Close reviews drawer" type="button" data-close>
                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                    <use href="#icon-close"/>
                </svg>
            </button>
            <div 
                class="reviews-drawer__drawer drawer__inner" role="dialog" aria-modal="true" 
                aria-label="Product reviews modal" tabindex="-1"
            >
                ${existingReviews  ? existingReviews  : visibleReviewsForm}
            </div>
        `));
    }

    renderLoadMoreButton(page) {
        return `
            <button type="button" data-load-more data-page="${page || 2}" class="button mt-3 mb-5">
                ${this.productReviews.dataset.loadText}
            </button>
        `;
    }

    replaceReviews(data) {
        const reviews = data.data;

        this.querySelector('[data-reviews-stack]').innerHTML =  BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            ${this.productReviews.renderSortButtons('drawer-stack', this.currentSort)}
            <div class="product-reviews__stack-cards" data-reviews-stack-cards>
                ${reviews.map(review => this.productReviews.renderReviewCard(review, {cardClasses: 'mb-3'})).join('')}
            </div>
            <div class="center">
                ${data.total > reviews.length ? this.renderLoadMoreButton(2) : ''}
            </div>
        `));

        this.querySelectorAll('[data-rating-filter-button]').forEach(button => {
            button.removeAttribute('data-active');
            button.classList.remove('product-rating-stars__button--active');
        });

        this.initInfiniteScroll();
    }

    fillBreakdown(summary) {
        for (const ratingType in summary.breakdown) {
            const button = this.querySelector(`button[data-${ratingType}]`);
            if (!button) {
                continue;
            }

            const count = summary.breakdown[ratingType];
            button.dataset.count = parseInt(count);
            if (!count) {
                button.setAttribute('aria-disabled', 'true');
                button.setAttribute('tabindex', -1);
            }
            button.querySelector('[data-count-text]').innerText = count;
        }
    }

    filterByRating(filterButton) {
        if (this.classList.contains('loading')) {
            return;
        }

        this.classList.add('loading');

        const params = {
            sortReviews: 'lowest-rating',
            minRating: filterButton.dataset.ratingScore
        };

        this.productReviews.fetchReviews(params)
            .then(response => {
                this.replaceReviews(response);
                filterButton.dataset.active = "true";
                filterButton.classList.add('product-rating-stars__button--active');
            })
            .finally(() => this.classList.remove('loading'));
    }

    loadMoreReviews(loadButton) {
        loadButton.classList.add('loading');

        const params = {page: loadButton.dataset.page};
        const activeSortButton = this.querySelector('reviews-sort button[data-active="true"]');
        if (activeSortButton) {
            params.sortReviews = activeSortButton.value;
        }

        const activeFilter = this.querySelector('[data-rating-filter-button][data-active="true"]');
        if (activeFilter) {
            params.sortReviews = 'lowest-rating';
            params.minRating = activeFilter.dataset.ratingScore;
        }

        this.productReviews.fetchReviews(params)
            .then(response => {
                if (document.activeElement === loadButton) {
                    // If we focused on the load button we should move the focus to the last vote up button
                    // because new reviews will be injected after it
                    const reviewLikeButtons = this.querySelectorAll('button[data-vote-up]');
                    if (reviewLikeButtons.length) {
                        reviewLikeButtons[reviewLikeButtons.length - 1].focus();
                    }
                }
                this.querySelector('[data-reviews-stack-cards]').insertAdjacentHTML(
                    'beforeend',
                    BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                        ${response.data.map(review => this.productReviews.renderReviewCard(review, {cardClasses: 'mb-3'})).join('')}
                    `))
                );

                loadButton.dataset.page = response.page + 1;
                if (response.data.length < this.productReviews.dataset.fetchLimit) {
                    loadButton.classList.add('hidden');
                }
            })
            .finally(() => loadButton.classList.remove('loading'));
    }

    initInfiniteScroll() {
        const loadButton = this.querySelector('button[data-load-more]');
        if (!loadButton) {
            return;
        }

        const intersectionObserver = new IntersectionObserver(entries => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    loadButton.click();
                }
            });
        }, {
            root: loadButton.closest('.reviews-drawer__drawer'),
            rootMargin: '500px'
        });

        intersectionObserver.observe(loadButton);
    }

    open(opener) {
        this.opener = opener;
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => this.classList.add('animate', 'active'));
        this.trapScrollAndFocus();
    }

    close() {
        document.body.classList.remove('overflow-hidden');
        this.classList.remove('active');
        removeTrapFocus(this.opener);
    }

    isOpen() {
        return this.classList.contains('active');
    }

    trapScrollAndFocus(trapFocusTimeout = 200) {
        const conditionallyTrapFocus = () => {
            if (this.isOpen()) {
                trapFocus(this, this.querySelector('.reviews-drawer__drawer'));
                document.body.classList.add('overflow-hidden');
            }
        };

        if (trapFocusTimeout) {
            setTimeout(conditionallyTrapFocus, trapFocusTimeout);
        } else {
            conditionallyTrapFocus();
            document.body.classList.add('overflow-hidden');
        }
    }
}

customElements.define('reviews-drawer', ReviewsDrawer);

class ReviewFormOpener extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', () => {
            const button = this.querySelector('button');
            const drawer = this.closest('reviews-drawer');
            const form = drawer.querySelector('review-form');
            if (form.classList.contains('hidden')) {
                form.classList.remove('hidden');
                form.querySelector('[name="author"]').focus();
                button.setAttribute('aria-expanded', 'true');
            } else {
                form.classList.add('hidden');
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }
}

customElements.define('review-form-opener', ReviewFormOpener);

class ReviewForm extends HTMLElement {
    connectedCallback() {
        this.productReviews = this.closest('reviews-drawer').productReviews;

        this.render();

        this.querySelector('form').addEventListener('submit', event => this.writeReview(event));

        const ratingRadios = this.querySelectorAll('[name="reviewRating"]');
        ratingRadios.forEach(ratingRadio => ratingRadio.addEventListener('change', event => {
            const value = event.target.value;
            ratingRadios.forEach(radio => {
                if (parseInt(radio.value) < parseInt(value)) {
                    radio.setAttribute('data-active', '');
                } else {
                    radio.removeAttribute('data-active');
                }
            });
        }));
    }

    render() {
        const nameText = this.productReviews.dataset.formNameText;
        const emailText = this.productReviews.dataset.formEmailText;
        const ratingText = this.productReviews.dataset.formRatingText;
        const titleText = this.productReviews.dataset.formTitleText;
        const messageText = this.productReviews.dataset.formMessageText;
        const imageText = this.productReviews.dataset.formImageText;
        const submitText = this.productReviews.dataset.formSubmitText;

        this.innerHTML =  BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
            <h3 class="h5 h4-desktop uppercase letter-spacing-1 light-weight left mb-4">
                ${this.productReviews.dataset.writeText}
            </h3>
            <form>
                <input type="hidden" name="productId" value="${this.productReviews.dataset.productId}" />
                <input type="hidden" name="productUrl" value="${this.productReviews.dataset.productUrl}" />
                <div class="field mb-3">
                    <input class="field__input" type="text" name="author" required id="form-name-${this.productReviews.dataset.sectionId}" placeholder="${nameText}">
                    <label class="field__label" for="form-name-${this.productReviews.dataset.sectionId}">${nameText}</label>
                </div>
                <div class="field mb-3">
                    <input class="field__input" type="email" name="email" required id="form-email-${this.productReviews.dataset.sectionId}" placeholder="${emailText}">
                    <label class="field__label" for="form-email-${this.productReviews.dataset.sectionId}">${emailText}</label>
                </div>
                <fieldset class="block border-none review-form__rating pl-0 pr-0 pt-0 pb-0 mb-3 ml-0 mr-0">
                    <legend class="mb-2">${ratingText}</legend>
                    <input type="radio" name="reviewRating" value="1" id="form-rating-1-${this.productReviews.dataset.sectionId}" data-active/>
                    <label for="form-rating-1-${this.productReviews.dataset.sectionId}">
                        <span class="review-rating-star"><span class="visually-hidden">1 star</span></span>
                    </label>
                    <input type="radio" name="reviewRating" value="2" id="form-rating-2-${this.productReviews.dataset.sectionId}" data-active/>
                    <label for="form-rating-2-${this.productReviews.dataset.sectionId}">
                        <span class="review-rating-star"><span class="visually-hidden">2 stars</span></span>
                    </label>
                    <input type="radio" name="reviewRating" value="3" id="form-rating-3-${this.productReviews.dataset.sectionId}" data-active/>
                    <label for="form-rating-3-${this.productReviews.dataset.sectionId}">
                        <span class="review-rating-star"><span class="visually-hidden">3 stars</span></span>
                    </label>
                    <input type="radio" name="reviewRating" value="4" id="form-rating-4-${this.productReviews.dataset.sectionId}" data-active/>
                    <label for="form-rating-4-${this.productReviews.dataset.sectionId}">
                        <span class="review-rating-star"><span class="visually-hidden">4 stars</span></span>
                    </label>
                    <input type="radio" name="reviewRating" value="5" checked id="form-rating-5-${this.productReviews.dataset.sectionId}"/>
                    <label for="form-rating-5-${this.productReviews.dataset.sectionId}">
                        <span class="review-rating-star"><span class="visually-hidden">5 stars</span></span>
                    </label>
                </fieldset>
                <div class="field mb-3">
                    <input class="field__input" type="text" name="reviewTitle" required id="form-title-${this.productReviews.dataset.sectionId}" placeholder="${titleText}">
                    <label class="field__label" for="form-title-${this.productReviews.dataset.sectionId}">${titleText}</label>
                </div>
                <div class="field mb-3">
                    <textarea
                            class="field__input" type="text" name="reviewMessage" required id="form-message-${this.productReviews.dataset.sectionId}"
                            placeholder="${messageText}" style="height: 15rem"
                    ></textarea>
                    <label class="field__label" for="form-title-${this.productReviews.dataset.sectionId}">${messageText}</label>
                </div>
                <div class="mb-4">
                    <label for="form-image-${this.productReviews.dataset.sectionId}" class="cursor-pointer">${imageText} </label>
                    <input type="file" name="image0" id="form-image-${this.productReviews.dataset.sectionId}" class="cursor-pointer"/>
                </div>
                
                <button type="submit" class="button uppercase letter-spacing-1 button--full-width">${submitText}</button>
            </form>
            <div data-form-feedback aria-live="polite"></div>
        `));
    }

    writeReview(event) {
        event.preventDefault();

        const button = this.querySelector('button[type="submit"]');
        if (button.classList.contains('loading')) {
            return;
        }

        const feedback = this.querySelector('[data-form-feedback]');

        button.classList.add('loading');
        feedback.innerHTML = '';

        const data = BryanAnthonys.makePostConfig('javascript');
        data.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete data.headers['Content-Type'];
        data.body = new FormData(event.target);

        const url = new URL('https://stamped.io/api/reviews3');
        url.searchParams.append('apiKey', this.productReviews.dataset.apiKey);
        url.searchParams.append('storeUrl', this.productReviews.dataset.store);

        fetch(url, data)
            .then(BryanAnthonys.decodeJsonResponse)
            .then(() => {
                this.querySelector('form').classList.add('hidden');

                feedback.innerHTML =  BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                    <div class="status-banner status-banner--success">
                        <h3 class="h4 mb-2">${this.productReviews.dataset.formSuccessTitleText}</h3>
                        ${this.productReviews.dataset.formSuccessMessageText}
                    </div>
                `));
            })
            .catch(error => {
                feedback.innerHTML =  BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                    <div class="status-banner status-banner--error mt-3">
                        ${BryanAnthonys.strings.general.genericAjaxError}
                    </div>
                `));

                console.error(error);
            })
            .finally(() => button.classList.remove('loading'));
    }
}

customElements.define('review-form', ReviewForm);

class ReviewCardFooter extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', event => {
            const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');
            if (button && button.hasAttribute('data-votes')) {
                this.voteReview(button);
            }
        });
    }

    voteReview(button) {
        const productReviews = document.querySelector('product-reviews');
        button.setAttribute('disabled', '');

        const data = BryanAnthonys.makePostConfig('json');
        data.headers['X-Requested-With'] = 'XMLHttpRequest';
        data.body = JSON.stringify({
            productId: this.closest('[data-product-id]').dataset.productId,
            reviewId: this.dataset.reviewId,
            apiKey: productReviews.dataset.apiKey,
            storeUrl: productReviews.dataset.store,
            vote: 1
        });

        fetch('https://stamped.io/api/reviews/vote', data)
            .then(BryanAnthonys.decodeJsonResponse)
            .then(response => {
                button.dataset.votes = `(${response.voteUp})`;
                button.querySelector('img').src = document.querySelector('product-reviews').dataset.iconHeartSolidSrc;
            })
            .finally(() => button.removeAttribute('disabled'));
    }
}

customElements.define('review-card-footer', ReviewCardFooter);

class ReviewModalOpener extends HTMLElement {
    connectedCallback() {
        this.id = `review-modal-opener-${Math.round(Math.random() * 100000)}`;
        this.addEventListener('click', () => this.openCustomerPhotoModal());
    }

    initialize() {
        const image = this.querySelector('img');
        image.src = `${this.dataset.cdnUrl}/${this.getReview().reviewUserPhotos.split(',').filter(Boolean)[0]}`;
    }

    openCustomerPhotoModal(button) {
        const review = this.getReview();

        const productReviews = document.querySelector('product-reviews');
        const cdnUrl = productReviews.dataset.customerImageCdn;
        const photos = review.reviewUserPhotos.split(',').filter(Boolean).map(photo => {
           const image = document.createElement('img');
           image.src = `${cdnUrl}/${photo}`;

           return image;
        });

        const modalId = `review-customer-photo-${this.dataset.modalId}`;
        let modal = document.getElementById(modalId);

        if (!modal) {
            document.body.insertAdjacentHTML('beforeend',  BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(`
                <modal-dialog id="${modalId}" class="custom-modal custom-modal--centered review-photo-modal">
                    <div class="custom-modal__content" role="dialog" aria-modal="true" tabindex="-1" aria-label="Customer review photo" style="--max-width: 90rem;">
                        <button id="ModalClose-${modalId}" class="custom-modal__toggle" aria-label="Close modal" type="button">
                            <svg class="icon icon-close" aria-hidden="true" focusable="false">
                                <use href="#icon-close"/>
                            </svg>
                        </button>
                        <div class="custom-modal__content-info">
                            <div class="product-review-photo">
                                <div class="product-review-photo__details">
                                    ${productReviews.renderReviewCard(review, {cardClasses: 'mb-4'})}
                                    <review-modal-navigation class="flex justify-content-between" data-opener="${this.id}">
                                        <button class="link ${this.getPrev() === null ? 'hidden' : ''} link pl-0 pr-0 pt-2 pb-2 mb-3" data-prev="${this.getPrev()}">
                                            Previous
                                        </button>
                                        <button class="link ${this.getNext() === null ? 'hidden' : ''} link pl-0 pr-0 pt-2 pb-2 mb-3" data-next="${this.getNext()}">
                                            Next
                                        </button>
                                    </review-modal-navigation>
                                </div>
                                <div class="product-review-photo__photos">
                                    ${photos.map(() => `
                                        <img 
                                            data-customer-images alt="Photo uploaded by customer"  width="600" height="600" 
                                            loading="lazy" class="responsive-image block"
                                        />
                                    `).join('')}
                                </div>
                            </div>
                        </div>
                    </div>
                </modal-dialog>
            `)));

            document.getElementById(modalId).querySelectorAll('[data-customer-images]').forEach((image, key) => {
                image.src = photos[key].src;
            });

            modal = document.getElementById(modalId);
        }

        modal.show(button);
    }

    getReview() {
        return BryanAnthonys.unsafeDataBag[`review-data-${this.dataset.reviewId}`];
    }

    getNext() {
        const openers = this.getAllModalOpenersInList();
        const currentIndex = this.getCurrentIndex(openers);

        return currentIndex === null
            ? null
            : (currentIndex < (openers.length - 1) ? currentIndex + 1 : 0);
    }

    getPrev() {
        const openers = this.getAllModalOpenersInList();
        const currentIndex = this.getCurrentIndex(openers);

        return currentIndex === null
            ? null
            : ((currentIndex - 1) >= 0 ? (currentIndex - 1) : (openers.length - 1));
    }

    getCurrentIndex(openers) {
        let currentIndex = null;

        openers.forEach((opener, index) => {
            if (opener === this) {
                currentIndex = index;
            }
        });

        return currentIndex;
    }

    getAllModalOpenersInList() {
        if (!this.allOpeners) {
            const scrollableList = this.closest('.scrollable__list');
            if (scrollableList) {
                this.allOpeners = Array.from(scrollableList.querySelectorAll('review-modal-opener'));
            } else {
                this.allOpeners = [];
            }
        }

        return this.allOpeners;
    }
}

customElements.define('review-modal-opener', ReviewModalOpener);

class ReviewModalNavigation extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', event => {
            const button = event.target;
            let openerIndex = null;
            if (button.hasAttribute('data-prev')) {
                openerIndex = parseInt(button.dataset.prev);
            } else if (button.hasAttribute('data-next')) {
                openerIndex = parseInt(button.dataset.next);
            }

            if (openerIndex === null) {
                return;
            }

            const reviewOpener = document.getElementById(this.dataset.opener);

            if (reviewOpener) {
                this.closest('modal-dialog').hide();
                reviewOpener.getAllModalOpenersInList()[openerIndex].click();
            }
        });
    }
}

customElements.define('review-modal-navigation', ReviewModalNavigation);

class ReviewsSort extends HTMLElement {
    initialize() {
        if (this.dataset.currentSort && this.dataset.currentSort !== 'null') {
            const activeSort = this.querySelector(`button[value="${this.dataset.currentSort}"]`);
            activeSort.classList.remove('button--badge');
            activeSort.classList.add('button--shade');
            activeSort.dataset.active = 'true';
        }

        this.addEventListener('click', event => {
            if (event.target.nodeName === 'BUTTON') {
                this.changeSort(event.target);
            }
        });
    }

    getParentSection() {
        if (!this.parentSection) {
            if (this.dataset.position === 'section-stack') {
                this.parentSection = this.closest('product-reviews');
            } else {
                this.parentSection = this.closest('reviews-drawer');
            }
        }

        return this.parentSection;
    }

    changeSort(button) {
        if (this.getParentSection().classList.contains('loading')) {
            return;
        }

        this.getParentSection().classList.add('loading');

        const productReviews = this.dataset.position === 'section-stack'
            ? this.getParentSection()
            : this.getParentSection().productReviews;

        const params = {
            sortReviews: button.value
        };

        if (button.value === 'lowest-rating') {
            params.minRating = 1;
        }

        productReviews.fetchReviews(params)
            .then(response => {
                this.getParentSection().initialData = response;
                this.getParentSection().currentSort = button.value;
                if (this.dataset.position === 'section-stack') {
                    productReviews.section.innerHTML =  BryanAnthonys.htmlReviewedForSafety(BryanAnthonys.partiallySanitize(
                        productReviews.renderStack(response)
                    ));
                } else {
                    this.getParentSection().replaceReviews(response);
                    this.getParentSection().querySelector('[role="dialog"]').scrollTop = 0;
                }
            })
            .finally(() => this.getParentSection().classList.remove('loading'));
    }
}

customElements.define('reviews-sort', ReviewsSort);

class ReviewsDrawerOpener extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', () => {
            const productReviews = document.getElementById(this.dataset.id);
            if (!productReviews) {
                return;
            }

            productReviews.openDrawer(this);

            setTimeout(() => {
                const form = document.querySelector('reviews-drawer.active review-form');
                const formIsHidden = form && form.classList.contains('hidden');
                const opener = document.querySelector('reviews-drawer.active review-form-opener');

                if (this.hasAttribute('data-review-form')) {
                    if (opener && formIsHidden) {
                        opener.click();
                    }
                } else if (!formIsHidden && opener) {
                    // Reviews drawer was open with 'view reviews button' but the reviews form is hidden
                    opener.click();
                }
            }, 100);
        });
    }
}

customElements.define('reviews-drawer-opener', ReviewsDrawerOpener);

customElements.define('reviews-details', class extends HTMLElement {
    initialize() {
        this.closeDetailsOnOutsideClick = this.closeDetailsOnOutsideClick.bind(this);

        this.querySelector('details').addEventListener('toggle', event => {
            if (event.target.open) {
                document.addEventListener('click', this.closeDetailsOnOutsideClick);
            }
        });
    }

    closeDetailsOnOutsideClick(event) {
        if (!event.target.closest('product-reviews-breakdown')) {
            setTimeout(
                () => this.querySelector('details').removeAttribute('open'),
                50
            );
            document.removeEventListener('click', this.closeDetailsOnOutsideClick);
        }
    }
});

class ReviewsElementInitializer extends HTMLElement {
    connectedCallback() {
        if (typeof this.parentElement.initialize === 'function') {
            this.parentElement.initialize();
        }
    }
}

customElements.define('reviews-element-initializer', ReviewsElementInitializer);